////////////////////////////////////////
// # GOLDEN RULE!!!! HONOR ABOVE ALL!!!!
////////////////////////////////////////
// NO NEW FILES!!!!!!!!!
////////////////////////////////////////

// I. FILE HEADER [WHITE #FFFFFF]
// ⚪ Contact Pea for Taytrom Publishing Co - Pure presentation component

// III. IMPORTS [GREEN #00FF00]
// 🟢 Third-party dependencies
import { FC } from 'react';
import styles from '../../../about/lobby/pea/TaytromPublishingCo_Kings_Home_SRC_About_Lobby_Pea.module.css';

// IV. INDEPENDENT CONSTANTS [TEAL #00FFFF]
// 🔵 Component props interface
interface FormData {
  name: string;
  email: string;
  company: string;
  message: string;
}

interface FormErrors {
  name?: string;
  email?: string;
  company?: string;
  message?: string;
}

type SubmitStatus = 'idle' | 'submitting' | 'success' | 'error';

interface PeaContactProps {
  formData: FormData;
  formErrors: FormErrors;
  submitStatus: SubmitStatus;
  submitMessage: string;
  onFieldChange: (fieldName: keyof FormData, value: string) => void;
  onFieldBlur: (fieldName: keyof FormData) => void;
  onSubmit: () => Promise<void>;
  className?: string;
}

// V. FUNCTION/CLASS NAME [BLUE #0000FF] - OUTPUT DECLARATION
// 🔵 Contact Pea Component
const Pea_Contact: FC<PeaContactProps> = ({
  formData,
  formErrors,
  submitStatus,
  submitMessage,
  onFieldChange,
  onFieldBlur,
  onSubmit,
  className
}) => {
  // X. RENDER/EXPORTS [BLACK #000000] - OUTPUT DELIVERY
  return (
    <div className={`${styles.contactContainer} ${className || ''}`}>
      {/* Navigation Header */}
      <header className={styles.navigationHeader}>
        <div className={styles.navigationContent}>
          <a href="/" className={styles.navigationBrand}>
            <svg width="28" height="28" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '10px', display: 'inline-block', verticalAlign: 'middle' }}>
              <defs>
                <linearGradient id="contactNavBulbGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style={{stopColor:'#6a1b9a',stopOpacity:1}} />
                  <stop offset="60%" style={{stopColor:'#9c27b0',stopOpacity:1}} />
                  <stop offset="100%" style={{stopColor:'#ffd700',stopOpacity:0.9}} />
                </linearGradient>
                <linearGradient id="contactNavFilamentGrad" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" style={{stopColor:'#fff9e6',stopOpacity:1}} />
                  <stop offset="100%" style={{stopColor:'#ffb300',stopOpacity:1}} />
                </linearGradient>
              </defs>
              <path d="M 100 20 C 130 20, 150 40, 150 70 C 150 90, 140 105, 130 120 C 125 130, 120 138, 120 145 L 120 155 L 80 155 L 80 145 C 80 138, 75 130, 70 120 C 60 105, 50 90, 50 70 C 50 40, 70 20, 100 20 Z" fill="url(#contactNavBulbGrad)" stroke="rgba(255,255,255,0.3)" strokeWidth="2"/>
              <circle cx="90" cy="95" r="3.5" fill="url(#contactNavFilamentGrad)"/>
              <circle cx="100" cy="95" r="3.5" fill="url(#contactNavFilamentGrad)"/>
              <circle cx="110" cy="95" r="3.5" fill="url(#contactNavFilamentGrad)"/>
              <rect x="80" y="155" width="40" height="8" rx="2" fill="#90a4ae"/>
              <rect x="80" y="165" width="40" height="6" rx="2" fill="#78909c" opacity="0.85"/>
            </svg>
            Taytrom Publishing Co.
          </a>
          <nav className={styles.navigationLinks}>
            <a href="/" className={styles.navigationLink}>
              Home
            </a>
            <a href="/library" className={styles.navigationLink}>
              Library
            </a>
            <a href="/ai-interviewer" className={styles.navigationLink}>
              AI Interviewer
            </a>
            <a href="/about" className={styles.navigationLink}>
              About
            </a>
            <a href="/contact" className={`${styles.navigationLink} ${styles.active}`}>
              Contact
            </a>
          </nav>
          <div className={styles.navigationActions}>
            <button onClick={() => window.location.href = '/ai-interviewer'} className={styles.navigationCtaButton}>
              Start AI Interview Now
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className={styles.heroSection}>
        <div>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '32px' }}>
            <svg width="600" height="180" viewBox="0 0 800 240" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ maxWidth: '100%', height: 'auto' }}>
              <defs>
                <linearGradient id="contactHeroTextGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" style={{stopColor:'#6a1b9a',stopOpacity:1}} />
                  <stop offset="35%" style={{stopColor:'#7b1fa2',stopOpacity:1}} />
                  <stop offset="65%" style={{stopColor:'#9c27b0',stopOpacity:1}} />
                  <stop offset="100%" style={{stopColor:'#ffd700',stopOpacity:1}} />
                </linearGradient>
                <linearGradient id="contactHeroAccentGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" style={{stopColor:'#ffb300',stopOpacity:1}} />
                  <stop offset="50%" style={{stopColor:'#ffd700',stopOpacity:1}} />
                  <stop offset="100%" style={{stopColor:'#ffb300',stopOpacity:1}} />
                </linearGradient>
                <linearGradient id="contactHeroBulbGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style={{stopColor:'#6a1b9a',stopOpacity:1}} />
                  <stop offset="60%" style={{stopColor:'#9c27b0',stopOpacity:1}} />
                  <stop offset="100%" style={{stopColor:'#ffd700',stopOpacity:0.9}} />
                </linearGradient>
                <radialGradient id="contactHeroGlowCompact" cx="50%" cy="40%">
                  <stop offset="0%" style={{stopColor:'#ffd700',stopOpacity:0.6}} />
                  <stop offset="100%" style={{stopColor:'#9c27b0',stopOpacity:0}} />
                </radialGradient>
                <linearGradient id="contactHeroFilamentCompact" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" style={{stopColor:'#fff9e6',stopOpacity:1}} />
                  <stop offset="100%" style={{stopColor:'#ffd700',stopOpacity:1}} />
                </linearGradient>
              </defs>
              <ellipse cx="100" cy="120" rx="80" ry="90" fill="url(#contactHeroGlowCompact)" opacity="0.3"/>
              <g transform="translate(20, 40)">
                <ellipse cx="80" cy="80" rx="50" ry="55" fill="url(#contactHeroGlowCompact)" opacity="0.4"/>
                <path d="M 80 30 C 100 30, 115 42, 115 60 C 115 75, 108 85, 102 95 C 99 100, 97 105, 97 110 L 97 118 L 63 118 L 63 110 C 63 105, 61 100, 58 95 C 52 85, 45 75, 45 60 C 45 42, 60 30, 80 30 Z" fill="url(#contactHeroBulbGradient)" stroke="rgba(255,255,255,0.3)" strokeWidth="2"/>
                <ellipse cx="70" cy="50" rx="15" ry="18" fill="rgba(255,255,255,0.3)" opacity="0.6"/>
                <circle cx="80" cy="65" r="3" fill="url(#contactHeroFilamentCompact)"/>
                <line x1="80" y1="68" x2="80" y2="80" stroke="url(#contactHeroFilamentCompact)" strokeWidth="2"/>
                <circle cx="75" cy="85" r="2" fill="#ffd700"/>
                <circle cx="80" cy="85" r="2" fill="#ffd700"/>
                <circle cx="85" cy="85" r="2" fill="#ffd700"/>
                <line x1="80" y1="87" x2="80" y2="95" stroke="url(#contactHeroFilamentCompact)" strokeWidth="2"/>
                <circle cx="80" cy="98" r="3" fill="#ffd700"/>
                <rect x="63" y="118" width="34" height="7" rx="2" fill="#90a4ae"/>
                <rect x="63" y="126" width="34" height="5" rx="2" fill="#78909c" opacity="0.8"/>
                <rect x="63" y="132" width="34" height="5" rx="2" fill="#607d8b" opacity="0.6"/>
                <ellipse cx="80" cy="142" rx="7" ry="3" fill="#546e7a"/>
              </g>
              <text x="210" y="100" fontFamily="'Inter', 'Helvetica Neue', sans-serif" fontSize="72" fontWeight="900" letterSpacing="-3" fill="url(#contactHeroTextGradient)">TAYLOR</text>
              <text x="210" y="150" fontFamily="'Inter', 'Helvetica Neue', sans-serif" fontSize="38" fontWeight="700" letterSpacing="-1" fill="url(#contactHeroAccentGradient)">PUBLISHING CO.</text>
              <text x="210" y="185" fontFamily="'Inter', 'Helvetica Neue', sans-serif" fontSize="20" fontWeight="500" letterSpacing="1" fill="#cfd8dc" opacity="0.7">IDEAS THAT ILLUMINATE</text>
              <line x1="210" y1="168" x2="280" y2="168" stroke="url(#contactHeroAccentGradient)" strokeWidth="2" opacity="0.6"/>
            </svg>
          </div>
          <h1 className={styles.heroTitle} style={{ display: 'none' }}>Get in Touch</h1>
          <h2 className={styles.heroSubtitle}>
            Let's discuss how Taytrom Publishing Co. can help tell your story
          </h2>
          <p className={styles.heroDescription}>
            Whether you're a technical founder looking for comprehensive third-party analysis or have questions about our AI Socratic Interviewer, we'd love to hear from you. Fill out the form below and we'll respond within 24 hours.
          </p>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className={styles.formSection}>
        <div className={styles.formContainer}>
          <form className={styles.form} onSubmit={(e) => { e.preventDefault(); onSubmit(); }}>
            {/* Name Field */}
            <div className={styles.formField}>
              <label htmlFor="name" className={styles.formLabel}>
                Name <span className={styles.required}>*</span>
              </label>
              <input
                id="name"
                type="text"
                className={`${styles.formInput} ${formErrors.name ? styles.inputError : ''}`}
                placeholder="Your full name"
                value={formData.name}
                onChange={(e) => onFieldChange('name', e.target.value)}
                onBlur={() => onFieldBlur('name')}
                disabled={submitStatus === 'submitting' || submitStatus === 'success'}
              />
              {formErrors.name && (
                <span className={styles.errorMessage}>{formErrors.name}</span>
              )}
            </div>

            {/* Email Field */}
            <div className={styles.formField}>
              <label htmlFor="email" className={styles.formLabel}>
                Email <span className={styles.required}>*</span>
              </label>
              <input
                id="email"
                type="email"
                className={`${styles.formInput} ${formErrors.email ? styles.inputError : ''}`}
                placeholder="your.email@company.com"
                value={formData.email}
                onChange={(e) => onFieldChange('email', e.target.value)}
                onBlur={() => onFieldBlur('email')}
                disabled={submitStatus === 'submitting' || submitStatus === 'success'}
              />
              {formErrors.email && (
                <span className={styles.errorMessage}>{formErrors.email}</span>
              )}
            </div>

            {/* Company Field */}
            <div className={styles.formField}>
              <label htmlFor="company" className={styles.formLabel}>
                Company <span className={styles.required}>*</span>
              </label>
              <input
                id="company"
                type="text"
                className={`${styles.formInput} ${formErrors.company ? styles.inputError : ''}`}
                placeholder="Your company name"
                value={formData.company}
                onChange={(e) => onFieldChange('company', e.target.value)}
                onBlur={() => onFieldBlur('company')}
                disabled={submitStatus === 'submitting' || submitStatus === 'success'}
              />
              {formErrors.company && (
                <span className={styles.errorMessage}>{formErrors.company}</span>
              )}
            </div>

            {/* Message Field */}
            <div className={styles.formField}>
              <label htmlFor="message" className={styles.formLabel}>
                Message <span className={styles.required}>*</span>
              </label>
              <textarea
                id="message"
                className={`${styles.formTextarea} ${formErrors.message ? styles.inputError : ''}`}
                placeholder="Tell us about your project, questions, or how we can help..."
                rows={6}
                value={formData.message}
                onChange={(e) => onFieldChange('message', e.target.value)}
                onBlur={() => onFieldBlur('message')}
                disabled={submitStatus === 'submitting' || submitStatus === 'success'}
              />
              {formErrors.message && (
                <span className={styles.errorMessage}>{formErrors.message}</span>
              )}
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className={`${styles.submitButton} ${submitStatus === 'submitting' ? styles.submitting : ''}`}
              disabled={submitStatus === 'submitting' || submitStatus === 'success'}
            >
              {submitStatus === 'submitting' ? (
                <>
                  <span className={styles.spinner}></span>
                  Sending...
                </>
              ) : submitStatus === 'success' ? (
                <>
                  ✓ Sent Successfully
                </>
              ) : (
                'Send Message'
              )}
            </button>

            {/* Status Message */}
            {submitMessage && (
              <div className={`${styles.statusMessage} ${submitStatus === 'success' ? styles.statusSuccess : styles.statusError}`}>
                {submitMessage}
              </div>
            )}
          </form>

          {/* Contact Info Sidebar */}
          <div className={styles.contactInfo}>
            <h3 className={styles.contactInfoTitle}>Other Ways to Reach Us</h3>
            
            <div className={styles.contactInfoItem}>
              <div className={styles.contactInfoIcon}>📧</div>
              <div>
                <h4 className={styles.contactInfoLabel}>Email</h4>
                <a href="mailto:contact@taylorpublishing.co" className={styles.contactInfoValue}>
                  contact@taylorpublishing.co
                </a>
              </div>
            </div>

            <div className={styles.contactInfoItem}>
              <div>
                <h4 className={styles.contactInfoLabel}>LinkedIn</h4>
                <a href="https://linkedin.com/company/taylor-publishing-co" className={styles.contactInfoValue}>
                  @taylor-publishing-co
                </a>
              </div>
            </div>

            <div className={styles.contactInfoItem}>
              <div>
                <h4 className={styles.contactInfoLabel}>Response Time</h4>
                <p className={styles.contactInfoValue}>
                  Within 24 hours (usually same day)
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className={styles.contactFooter}>
        <p>© 2025 Taytrom Publishing Co. All rights reserved.</p>
        <p>Comprehensive third-party analysis books for the AI era.</p>
      </footer>
    </div>
  );
};

export default Pea_Contact;
